module.exports = __webpack_public_path__ + "img/status-rank.06b18d3c.png";